module.exports = "<iframe [attr.src]=\"urlBi\" frameborder=\"0\" style=\"width: 100%; height: calc(100% - 64px)\" (load)=\"iframe($event)\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/bi/dashboard/dashboard.component.html
// module id = ./src/app/view/bi/dashboard/dashboard.component.html
// module chunks = main